module.exports = __webpack_public_path__ + "img/202403201608546395k1.7613b9bc.jpg";